import { ActionTree } from 'vuex'
import RootState from '@/store/RootState'
import ProjectState from "@/store/modules/project/ProjectState"

export const actions: ActionTree<ProjectState, RootState> = {
  setProject ({ commit }, project) {
    commit('setProject', project)
  },
  setHasRunningTracking ({ commit }, params: { running: boolean, projectId: string }) {
    commit('setHasRunningTracking', params)
  }
}
